// extracted by mini-css-extract-plugin
export default {"container":"BasicForm-module__container--dca3","fields":"BasicForm-module__fields--bde1","charCount":"BasicForm-module__charCount--a723"};